import { motion } from "framer-motion";
import deleteCircleIcon from "@icons/delete-circle.svg";
import Image from "next/image";

function ClearButton({
  className,
  visible,
  onClick,
}: {
  className?: string;
  visible: boolean;
  onClick: () => void;
}): JSX.Element {
  const variants = {
    visible: {
      opacity: 1,
      rotate: 0,
      display: "block",
    },
    hidden: {
      opacity: 0,
      rotate: -60,
      transitionEnd: {
        display: "none",
      },
    },
  };

  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate={visible ? "visible" : "hidden"}
      className={`cursor-pointer p-4 pr-2.5 normal:pr-6 z-10 ${className ? className : ""}`}
      onClick={onClick}
    >
      <Image
        src={deleteCircleIcon}
        className="cursor-pointer z-10"
        onClick={onClick}
        height={20}
        width={20}
        alt="clear"
      />
    </motion.div>
  );
}

export default ClearButton;
